export const CommonMixins = {
    deleteTooltip(obj={}, itemName="") {
        if (obj.deleted)
            return 'Already Deleted'
        else if (obj.can_delete === false)
            return `Can not delete default ${itemName}`
        else
            return 'Delete'
    },
    editTooltip(obj={},  itemName="") {
        if (obj.deleted)
            return `Cannot Edit Deleted ${itemName}`
        else
            return 'Edit'
    },
}
